import { Injectable } from '@angular/core';
import { ApiResponse, ProposalBillingItem } from 'app/entities';
import { ApiService } from 'app/services/api.service';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ProposalBillingItemService extends ApiService {
    findAll(proposalId: number) {
        return this.httpService.get(`/v1/clients/proposals/${proposalId}/billing-items`)
            .pipe(
                map(res => ApiResponse.parseWith(new ProposalBillingItem(), res) as ApiResponse<ProposalBillingItem[]>)
            );
    }

    bill(proposalId: number, itemId: number, data: any) {
        const formData = this.formDataFromObject(data);

        return this.httpService.post(`/v1/clients/proposals/${proposalId}/billing-items/${itemId}/bill`, formData)
            .pipe(map(res => ProposalBillingItem.parse(res.data) as ProposalBillingItem));
    }

    pay(proposalId: number, itemId: number, data: any) {
        const formData = this.formDataFromObject(data);

        return this.httpService.post(`/v1/clients/proposals/${proposalId}/billing-items/${itemId}/pay`, formData)
            .pipe(map(res => ProposalBillingItem.parse(res.data) as ProposalBillingItem));
    }
}
